/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ met: NonNullable<unknown>, total: NonNullable<unknown> }} Wrapped_Muscles_Target_CountInputs */

const en_us2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} of 1 muscle on target`);
	return /** @type {LocalizedString} */ (`${i?.met} of ${i?.total} muscles on target`)
	
};

const pt_br2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} de 1 músculo na meta`);
	return /** @type {LocalizedString} */ (`${i?.met} de ${i?.total} músculos na meta`)
	
};

const es_419_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} de 1 músculo en la meta`);
	return /** @type {LocalizedString} */ (`${i?.met} de ${i?.total} músculos en la meta`)
	
};

const pt_pt2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} de 1 músculo no objetivo`);
	return /** @type {LocalizedString} */ (`${i?.met} de ${i?.total} músculos no objetivo`)
	
};

const fr_fr2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} muscle sur 1 dans l'objectif`);
	return /** @type {LocalizedString} */ (`${i?.met} muscles sur ${i?.total} dans l'objectif`)
	
};

const de_de2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} von 1 Muskel im Ziel`);
	return /** @type {LocalizedString} */ (`${i?.met} von ${i?.total} Muskeln im Ziel`)
	
};

const it_it2_wrapped_muscles_target_count = /** @type {(inputs: Wrapped_Muscles_Target_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.met} di 1 muscolo in target`);
	return /** @type {LocalizedString} */ (`${i?.met} di ${i?.total} muscoli in target`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "{met} of 1 muscle on target" |
* | * | "{met} of {total} muscles on target" |
*
* @param {Wrapped_Muscles_Target_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_target_count = /** @type {((inputs: Wrapped_Muscles_Target_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_Target_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_target_count(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_target_count(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_target_count(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_target_count(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_target_count(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_target_count(inputs)
	return en_us2_wrapped_muscles_target_count(inputs)
});
export { wrapped_muscles_target_count as "wrapped.muscles_target_count" }